import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
// eslint-disable-next-line import/no-cycle
import { HotelCardTabs } from "./HotelCardTabs";
import { LOCAL_EN, LOCAL_FR } from "../../const/const";
// eslint-disable-next-line import/no-cycle

const HotelCardTabsConnector = ({ data, locale }) =>
	data?.merchandising && data?.merchandising.length > 0 ? (
		<HotelCardTabs
			data={data?.merchandising.filter(i => i)}
			locale={locale}
			renderLink={(item, { className }) => (
				<Link to={item.to} target={item.target} className={className} title={item.text}>
					<span className="sr-only">{item.text}</span>
				</Link>
			)}
		/>
	) : (
		<></>
	);
HotelCardTabsConnector.propTypes = {
	data: PropTypes.shape({
		merchandising: PropTypes.arrayOf(
			PropTypes.shape({
				Gateway: PropTypes.shape({
					Code: PropTypes.string,
					Name: PropTypes.string,
				}),
				PromotionGroups: PropTypes.arrayOf(
					PropTypes.shape({
						Description: PropTypes.string,
						Offers: PropTypes.arrayOf(
							PropTypes.shape({
								AccommodationInfo: PropTypes.shape({
									AccommodationCode: PropTypes.string,
									AccommodationName: PropTypes.string,
									StarRating: PropTypes.number,
								}),
								CalendarLink: PropTypes.string,
								DeepLink: PropTypes.string,
								DepartureDate: PropTypes.string,
								Destination: PropTypes.shape({
									CountryName: PropTypes.string,
									Name: PropTypes.string,
									ProviderCode: PropTypes.string,
								}),
								Duration: PropTypes.number,
								Gateway: PropTypes.shape({
									Code: PropTypes.string,
									Name: PropTypes.string,
								}),
								MealPlan: PropTypes.string,
								OfferType: PropTypes.string,
								Price: PropTypes.number,
								RegPrice: PropTypes.number,
								SaveUpto: PropTypes.number,
								tax: PropTypes.string,
							})
						),
						title: PropTypes.string,
					})
				),
			})
		),
	}).isRequired,
	locale: PropTypes.oneOf([LOCAL_FR, LOCAL_EN]),
};
HotelCardTabsConnector.defaultProps = {
	locale: LOCAL_EN,
};
export default HotelCardTabsConnector;
export { HotelCardTabsConnector };
